<div class="flex-column h-100">
  <odx-content-box>
    <div odxLayout="flex">
      @if (selectedFamily) {
        <h6 class="odx-title-6 header-prefix" i18n="@@flameDetectorConfiguration.variantSelector.headerPrefix">
          Variante für {{ selectedFamily.name }}
        </h6>
      }
    </div>
  </odx-content-box>

  <div class="configuration-wizard-header flex-column space-top">
    <h5
      class="odx-title-5"
      i18n="@@flameDetectorConfiguration.variantSelector.header"
      data-testid="flameDetectorConfiguration.variantSelector.header"
    >
      Brandmelder-Variante auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    <form [formGroup]="selectedVariantForm" class="overflow-hidden h-100">
      @if (filteredSelectableProducts.length > 0) {
        <odx-radio-group formControlName="selectedVariant" required="true" class="overflow-hidden h-100">
          <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
            @for (product of filteredSelectableProducts; track product) {
              <app-transmitter-card
                class="overflow-hidden"
                [transmitterData]="product"
                [showCosts]="showCosts"
                [isSelected]="selectedVariant?.id === product.id"
                (click)="select(product)"
                (transmitterSelected)="select(product)"
                >{{ product | localizeProductName }}</app-transmitter-card
              >
            }
          </div>
        </odx-radio-group>
      } @else {
        <app-refresh-products-hint dataType="Flammendetektor" i18n-dataType="@@global.flameDetectors"></app-refresh-products-hint>
      }
    </form>
  </odx-content-box>
</div>
